import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    margin-bottom: 15px;
`;

const Heading = styled.h2`
    color: #ff6c0e !important;
    margin: 0 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
`;

const DetailsInfoSection = ({ heading, children }) => (
    <Wrapper>
        <Heading>{heading}</Heading>
        {children}
    </Wrapper>
);

export default DetailsInfoSection;



// WEBPACK FOOTER //
// ./components/details/DetailsInfoSection.jsx